<template>
  <div class="pt-8 pb-5 px-6 sm:px-8 text-center">
    <!-- Brand Icon -->
    <div class="relative inline-block mx-auto mb-4">
      <div
        class="w-14 h-14 bg-gradient-to-br from-indigo-600 via-indigo-600 to-violet-600 rounded-2xl flex items-center justify-center text-white ring-4 ring-indigo-50 dark:ring-indigo-950/50"
      >
        <GraduationCap class="w-7 h-7 transform -rotate-3 transition-transform hover:rotate-0" />
      </div>
      <div
        class="absolute -bottom-1 -right-1 w-4 h-4 bg-emerald-500 rounded-full border-2 border-white dark:border-slate-900"
        title="System Active"
      ></div>
    </div>

    <!-- Badge -->
    <div class="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-indigo-50 dark:bg-indigo-950/60 text-indigo-700 dark:text-indigo-300 border border-indigo-100 dark:border-indigo-900/50 mb-2.5">
      <Sparkles class="w-3.5 h-3.5 text-indigo-500" />
      <span>Educanium Workspace</span>
    </div>

    <!-- Headings -->
    <h1 class="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900 dark:text-white">
      Welcome Back
    </h1>
    <p class="text-sm text-slate-500 dark:text-slate-400 mt-1 max-w-xs mx-auto">
      Sign in to manage attendance, classes, and school operations
    </p>
  </div>
</template>

<script setup>
import { GraduationCap, Sparkles } from "lucide-vue-next";
</script>
